// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"301":"ae962b31","904":"8aea4b40"}[chunkId] + ".chunk.css";
};